import {
    Box,
    Checkbox,
    Collapse,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
} from "@mui/material";
import { IOffer } from "../../interfaces/IOffer";
import { IOfferPosition } from "../../interfaces/IOfferPosition";
import { ArrowDownward, ArrowUpward, HelpOutline } from "@mui/icons-material";
import { OfferPositionCheckListItem } from "./OfferPositionCheckListItem";
import { useState } from "react";
import { useTheme } from "@mui/material/styles";
import { IOfferPositionCheckListItem } from "../../interfaces/IOfferPositionCheckListItem";

interface IProps {
    offer: IOffer;
    offerPosition: IOfferPosition;
    updateOfferPosition: Function;
}

export const OfferPositionCheckListOverview: React.FC<IProps> = ({ offer, offerPosition, updateOfferPosition }) => {
    const [expanded, setExpanded] = useState(false);
    const theme = useTheme();

    const updateOfferPositionCheckListItems = (checkListItems: IOfferPositionCheckListItem[]) => {
        const updatedOfferPosition: IOfferPosition = {
            ...offerPosition,
            checkListItems: checkListItems,
        };
        updateOfferPosition(offer, updatedOfferPosition);
    };

    const isCompleted = offerPosition.checkListItems.every((item) =>
        item.isPhotoRequired ? item.document_objects.length > 0 && item.isChecked : item.isChecked,
    );

    return (
        <Box mb={3}>
            <Box
                display="flex"
                alignItems="center"
                gap={2}
                mb={2}
                sx={{
                    cursor: "pointer",
                    "&:hover": { backgroundColor: "#f5f5f5" },
                    borderRadius: 1,
                    px: 1,
                    py: 1,
                }}
                onClick={() => setExpanded(!expanded)}
            >
                <IconButton size="small" edge="start">
                    {expanded ? <ArrowUpward /> : <ArrowDownward />}
                </IconButton>
                <Typography variant="h6" sx={{ flexGrow: 1 }}>
                    {offerPosition.title}
                </Typography>
                <Typography color={isCompleted ? theme.palette.primary.main : theme.palette.info.main}>
                    {isCompleted ? "Erledigt" : "Offen"}
                </Typography>
            </Box>

            <Collapse in={expanded}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell width="15%">Titel</TableCell>
                            <TableCell width="15%">Info</TableCell>
                            <TableCell width="20%">
                                <Box display="flex" alignItems="center" gap={1}>
                                    Foto notwendig
                                    <Tooltip title="Bei Häkchen - Das Abhaken des Checklisteintrag ist erst nach dem Hochladen eines Dokuments möglich.">
                                        <HelpOutline fontSize="small" />
                                    </Tooltip>
                                </Box>
                            </TableCell>
                            <TableCell width="20%">Anzahl der Dokumente</TableCell>
                            <TableCell width="20%">Dokumente verwalten</TableCell>
                            <TableCell width="10%">
                                <Checkbox checked={true} disabled />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {offerPosition.checkListItems
                            .sort((a, b) => (a.position < b.position ? -1 : 1))
                            .map((item, index) => (
                                <OfferPositionCheckListItem
                                    key={item.id}
                                    checkListItem={item}
                                    index={index}
                                    checkListItems={offerPosition.checkListItems}
                                    setCheckListItems={updateOfferPositionCheckListItems}
                                />
                            ))}
                    </TableBody>
                </Table>
            </Collapse>
        </Box>
    );
};
